export interface BatchStatisticsMonthlyOutputRequest {
  outputMonth: string
  batchType: string
}

export function BatchStatisticsMonthlyOutputRequestToJSON(
  value: BatchStatisticsMonthlyOutputRequest
): any {
  return {
    output_month: value.outputMonth,
    batch_type: value.batchType
  }
}
